import { modeTypes, ModeTypes } from '@/constants/modes';
import {
  localizeServices,
  LocalizeServices,
  localizeServicesMap,
  querySerevice,
  queryServicesMap,
  restServices,
  RestServices,
  restServicesMap,
  timeService,
  timeServiceMap,
} from '@/constants/services';

class ServicesFactory {
  mode: ModeTypes;
  constructor(mode: ModeTypes) {
    this.mode = mode;
  }

  private createRest(service: RestServices) {
    return new restServicesMap[service]();
  }

  private createLocalize(service: LocalizeServices) {
    return new localizeServicesMap[service]();
  }

  getRest() {
    if (this.mode === modeTypes.development) {
      return this.createRest(restServices.restDev);
    }

    if (this.mode === modeTypes.mock) {
      return this.createRest(restServices.restMock);
    }

    return this.createRest(restServices.restProd);
  }

  getQuery() {
    return new queryServicesMap[querySerevice]();
  }

  getTime() {
    return new timeServiceMap[timeService]();
  }

  getLocalize() {
    if (
      this.mode === modeTypes.development ||
      this.mode === modeTypes.production
    ) {
      return this.createLocalize(localizeServices.localize);
    }

    if (this.mode === modeTypes.mock) {
      return this.createLocalize(localizeServices.localizeMock);
    }
  }
}

export default ServicesFactory;
